import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { EditHeaderComponent } from './common/components/edit-header/edit-header.component';
import { EditToolBarComponent } from './common/components/edit-tool-bar/edit-tool-bar.component';
import { ProjectSelecteToolComponent } from './common/components/project-selecte-tool/project-selecte-tool.component';
import { ColorSettingToolComponent } from './common/components/color-setting-tool/color-setting-tool.component';
import { PartSettingToolComponent } from './common/components/part-setting-tool/part-setting-tool.component';
import { ShareSettingToolComponent } from './common/components/share-setting-tool/share-setting-tool.component';
import { Subject, take, takeUntil } from 'rxjs';
import { EmbedData } from './common/data/embed';
import { EmbedService } from '../embed-layout/common/services/embed.service';
import { ThreeGraphqlService } from 'src/app/core/graphql/three/services/three-graphql.service';
import { PresetSettingToolComponent } from './common/components/preset-setting-tool/preset-setting-tool.component';

@Component({
  selector: 'edit-layout',
  imports: [
    RouterOutlet,
    EditHeaderComponent,
    EditToolBarComponent,
    ProjectSelecteToolComponent,
    ColorSettingToolComponent,
    PartSettingToolComponent,
    ShareSettingToolComponent,
    PresetSettingToolComponent,
  ],
  templateUrl: './edit-layout.component.html',
  styleUrl: './edit-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditLayoutComponent implements OnInit, OnDestroy {
  public selectedSidebarIndex: number = 0;

  public embedData: EmbedData | undefined;

  private unsubscribeAll: Subject<any> = new Subject();

  constructor(
    private threeGraphqlService: ThreeGraphqlService,
    private route: ActivatedRoute,
    private embedService: EmbedService,
    private cd: ChangeDetectorRef,
  ) {}

  //--------------------------------------------------------------------------------------------------------
  // @ Life Circle
  //--------------------------------------------------------------------------------------------------------

  ngOnInit(): void {
    this.getEmbedData();
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
    this.unsubscribeAll.unsubscribe();
  }

  //--------------------------------------------------------------------------------------------------------
  // @ Public Method
  //--------------------------------------------------------------------------------------------------------

  public onChangeSelectedSidebarIndex(index: number): void {
    this.selectedSidebarIndex = index;
    this.cd.markForCheck();
  }

  //--------------------------------------------------------------------------------------------------------
  // @ Private Method
  //--------------------------------------------------------------------------------------------------------

  private getEmbedData(): void {
    this.embedService.embedData$
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe((embedData: EmbedData | undefined) => {
        if (!embedData) return;
        this.embedData = embedData;
        this.cd.markForCheck();
      });
  }
}
